<template>
  <div id="app">
    <banner></banner>
    <div id="content">
      <div class="container">
        <router-view></router-view>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import VueRouter from 'vue-router';

import Banner from './components/Banner.vue';
import MyFooter from './components/Footer.vue';
import Contact from './components/Contact.vue';
import Register from './components/Register.vue';
import Responses from './components/Responses.vue';
import Thanks from './components/Thanks.vue';

const routes = [
  { path: '/respostas', component: Responses },
  { path: '/obrigado', component: Thanks },
  { path: '/contato', component: Contact },
  { path: '/', component: Register },
  { path: '*', redirect: '/' },
];

const router = new VueRouter({
  routes,
});

export default {
  router,
  name: 'app',
  components: {
    Banner,
    MyFooter,
  },
}
</script>

<style>
html {
  font-size: 16px;
}

@media (min-width: 576px) {
  html {
    font-size: 24px;
  }
}

#app {
  font-family: 'Frutiger 57Cn', 'Avenir', Helvetica, Arial, sans-serif;
  font-weight: normal;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#content {
  padding: 3rem 0 3.4rem;
  background: #F26722;
  color: #fff;
}

h1, h2, h3, h4, h5 {
  font-family: 'SC Gum Kids';
  font-weight: normal;
  font-style: normal;
}

#content h2 {
  margin-bottom: 0.4em;
  font-size: 2.2rem;
  line-height: 1.2em;
  text-transform: uppercase;
  color: #F6FCAE;
}
</style>



// WEBPACK FOOTER //
// App.vue?e26f5b6e